<!--
  VHeader

  還原自 index.pretty.js L1673。render function 已轉回 template。

  頁首橫幅：店名、營業狀態（備餐時間或休息提示）、資訊按鈕與購物車按鈕。
  is_close 為 true 時整個 nav 收合成較矮的樣式（class="close"）。
-->

<template>
  <nav class="navbar">
    <div
      class="nav-img"
      style="background-image: url('/microX2Sugar291OrderReceive.jpg')"
    >
      <div
        class="nav-container d-flex fd-column-full jc-space"
        :class="{ close: is_close }"
      >
        <div class="nav-content d-flex jc-space">
          <div></div>
        </div>

        <div class="nav-content d-flex jc-space" :class="{ open: !is_close }">
          <div class="nav-wrapper">
            <div class="title">
              <p class="font-36">微微糖・青埔形象店</p>
            </div>

            <div class="info m-t-12">
              <div v-if="is_close === false" class="d-flex a-center">
                <i class="material-icons m-r-8">access_time</i>
                <p class="font-16">{{ $t('preparation', { msg: time }) }}</p>
              </div>
              <div v-else class="d-flex a-center">
                <i class="material-icons m-r-8 close">report_problem</i>
                <p class="font-16">{{ $t('close') }}</p>
              </div>
            </div>
          </div>

          <div class="nav-collapse d-flex">
            <button
              class="btn btn-img btn-white btn-round d-flex a-center as-flex-end"
              @click="trigger_info"
            >
              <i class="material-icons">info</i>
            </button>

            <button
              v-if="cart_actived"
              class="btn btn-img-msg btn-white btn-round d-flex a-center as-flex-end m-l-8"
              @click="trigger_cart"
            >
              <i class="material-icons m-r-8">shopping_cart</i>
              <p class="s-screen m-r-4">{{ $t('your_cart') }} • </p>
              <p>{{ total_count }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: ['is_close', 'total_count', 'cart_actived', 'time'],

  data() {
    return {}
  },

  methods: {
    trigger_info() {
      window.open('https://www.facebook.com/micro.x2.sugar.291', '_blank')
    },

    trigger_cart() {
      this.$emit('event', 'trigger_cart')
    }
  }
}
</script>
